module.exports = __webpack_public_path__ + "media/images/signatures/edelmira_lopez-e372e052cd83b304ef3c5db24fc7ecd7.png";